import EmployeeCollectionTable from "../components/EmployeeCollectionTable";
import styled from "@emotion/styled";
import TextSearch from "../../common/atoms/TextSearch";
import { ExportExcelIcon } from "../../common/atoms/SvgIcons";
import Typography from "../../common/atoms/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { RatingService } from "../../business-card-management/services/RatingService";
import { useCallback, useEffect, useState } from "react";
import { formatDate } from "../../common/helpers/dates.utils";
import { downloadResponseBase64File } from "../../common/helpers/files.utils";
import { debounce } from "../../common/helpers/functions";

const PageLayout = styled.div`
  width: 100%;
  @media (max-width: 480px) {
    padding: 0;
  }
`;

const MainContainer = styled.div`
  flex-wrap: wrap;
  gap: 30px;
`;

const HeaderContainer = styled.div`
  display: flex;
`;

const ExportExcelButtonContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  min-width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const TableContainer = styled.div`
  width: 100%;
  margin-top: 30px;
`;

const BackContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  cursor: pointer;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

const BackButton = ({ handleClick }) => {
  return (
    <BackContainer onClick={handleClick}>
      <ArrowBackIcon />
      <Typography variant="small">Volver</Typography>
    </BackContainer>
  );
};

const EmployeeCollection = () => {
  const [collection, setCollection] = useState([]);
  const [userName, setUserName] = useState("");
  const { cardId } = useParams();
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const [search, setSearch] = useState("");
  const handleSearch = (event) => {
    const value = event.nativeEvent.target.value;
    setSearch(value);
  };
  const debouncedChangeHandler = useCallback(debounce(handleSearch, 300), []);

  const handleDownload = () => {
    if (!cardId) return;
    RatingService.getGeneralCollectionByCardReport(cardId, search).then(
      (response) => {
        downloadResponseBase64File(response);
      }
    );
  };

  useEffect(() => {
    if (cardId) {
      RatingService.getGeneralCollectionByCard(cardId, search).then(
        (response) => {
          if (response.data.employee) {
            const employee = response.data.employee;
            setUserName(`${employee.name} ${employee.lastname}`);
          }
          if (response.data.collection) {
            setCollection(
              response.data.collection.map((item, index) => ({
                id: index + 1,
                dateHour: formatDate(new Date(item.updatedAt)),
                DNI: item.contact.dni,
                phoneNumber: item.contact.phoneNumber || "",
                referal: `${item.businessCardRated.baseInformation.name} ${item.businessCardRated.baseInformation.lastname}`,
                Calification: item.ratingValue,
              }))
            );
          }
        }
      );
    }
  }, [cardId, search]);

  return (
    <PageLayout>
      <MainContainer>
        <BackButton handleClick={handleBack} />
        <HeaderContainer>
          <TextSearch onSearch={debouncedChangeHandler} />
          <ExportExcelButtonContainer onClick={handleDownload}>
            <ExportExcelIcon />
          </ExportExcelButtonContainer>
        </HeaderContainer>
        <NameContainer>
          <Typography variant="small">
            Estas viendo la tabla del usuario "{userName}"
          </Typography>
        </NameContainer>
        <TableContainer>
          <EmployeeCollectionTable data={collection} />
        </TableContainer>
      </MainContainer>
    </PageLayout>
  );
};

export default EmployeeCollection;
